import {
  facebookConnectionResponseSchema,
  selectFacebookPageRequestSchema,
  type FacebookConnectionResponse,
  type SelectFacebookPageRequest,
} from "@multi-chat/shared";
import { apiDelete, apiGet, apiPost } from "./client.js";

function orgBase(organizationId: number): string {
  return `/organizations/${organizationId}/facebook`;
}

export async function getFacebookConnection(
  organizationId: number,
  signal?: AbortSignal,
): Promise<FacebookConnectionResponse> {
  return facebookConnectionResponseSchema.parse(
    await apiGet(orgBase(organizationId), signal),
  );
}

export async function selectFacebookPage(
  organizationId: number,
  pageId: string,
  signal?: AbortSignal,
): Promise<FacebookConnectionResponse> {
  const body: SelectFacebookPageRequest = selectFacebookPageRequestSchema.parse({ pageId });
  return facebookConnectionResponseSchema.parse(
    await apiPost(`${orgBase(organizationId)}/pages/select`, body, signal),
  );
}

export async function cancelPendingFacebook(
  organizationId: number,
  signal?: AbortSignal,
): Promise<FacebookConnectionResponse> {
  return facebookConnectionResponseSchema.parse(
    await apiDelete(`${orgBase(organizationId)}/pending`, signal),
  );
}

export async function disconnectFacebook(
  organizationId: number,
  signal?: AbortSignal,
): Promise<FacebookConnectionResponse> {
  return facebookConnectionResponseSchema.parse(
    await apiDelete(orgBase(organizationId), signal),
  );
}
